import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'redux-form';
import { toIdString } from '../../utils/common';
import { getClassName, checkButtonDisabled } from '../../utils/forms';
import InputField from '../shared/InputField';

export default class SuperadminEditForm extends React.Component {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    dataset: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    updateDatasetFunction: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    currDataset: PropTypes.number.isRequired,
    cancelFormFunction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit = params => {
    const { updateDatasetFunction } = this.props;
    updateDatasetFunction(params);
  };

  renderStatusSelect = ({ input, label, meta: { touched, error } }) => (
    <div className={getClassName(touched, error)}>
      <label htmlFor={toIdString(label)} className="form-control-label">
        {label} {touched && error && <span>| {error}</span>}
      </label>
      <div>
        <select {...input} id={toIdString(label)}>
          <option value="0">Disabled</option>
          <option value="1">Enabled</option>
        </select>
      </div>
    </div>
  );

  renderStateSelect = ({ input, label, meta: { touched, error } }) => (
    <div className={getClassName(touched, error)}>
      <label htmlFor={toIdString(label)} className="form-control-label">
        {label} {touched && error && <span>| {error}</span>}
      </label>
      <div>
        <select {...input} id={toIdString(label)}>
          <option value="WAITING_FOR_CUSTOMER_LAYOUT">Waiting for Customer Layout</option>
          <option value="REVIEW_PENDING">Review Pending</option>
          <option value="UNDER_REVIEW">Under Review</option>
          <option value="APPROVED">Approved</option>
        </select>
      </div>
    </div>
  );

  renderAdminFields = () => (
    <div>
      <Field
        name="s3Path"
        type="text"
        component={InputField}
        label="S3 Path"
        placeholder="S3 Path"
      />
      <Field
        name="searchHost"
        type="text"
        component={InputField}
        label="Search Host"
        placeholder="Search Host"
      />
      <Field name="code" type="text" component={InputField} label="Code" placeholder="Code" />
      <Field
        name="customType"
        type="text"
        component={InputField}
        label="Custom Type"
        placeholder="Custom Type (optional)"
      />
      <div className="row">
        <div className="col-md-6">
          <Field
            name="incrementalUpdates"
            type="checkbox"
            component={InputField}
            label="Incremental Updates"
          />
        </div>
        <div className="col-md-6">
          <Field
            name="autoVersionUpdates"
            type="checkbox"
            component={InputField}
            label="Auto Version Updates"
          />
        </div>
      </div>
      <Field name="state" component={this.renderStateSelect} label="State" />
    </div>
  );

  render() {
    const {
      invalid,
      submitting,
      isAdmin,
      handleSubmit,
      currDataset,
      cancelFormFunction,
    } = this.props;

    const nextPage = `/data/dataset/${currDataset}`;

    return (
      <Form id="superadminEditForm" onSubmit={handleSubmit(this.submit)}>
        <fieldset>
          <Field name="status" component={this.renderStatusSelect} label="Status" />
          <Field
            name="name"
            type="text"
            component={InputField}
            label="Name"
            placeholder="List Name"
          />
          {isAdmin ? this.renderAdminFields() : null}
        </fieldset>
        <div className="form-buttons">
          <p className="pull-right">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                cancelFormFunction(nextPage);
              }}>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={checkButtonDisabled(invalid, submitting)}>
              Update List
            </button>
          </p>
        </div>
      </Form>
    );
  }
}
